module.exports = __webpack_public_path__ + "static/media/Vocal_Form_5.38eb03aa.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/24-25/Vocal_Form_5.pdf
// module id = 229
// module chunks = 0